<template>
  <div
    v-if="hasBanners"
    :class="classes"
  >
    <vue-client-only>
      <swiper
        v-if="isSliderMode"
        :items="BANNERS"
        v-slot="{ item }"
        dots
        :slides-to-show="2"
      >
        <banner
          :data="item"
          :slot-name="slotName"
        />
      </swiper>
      <div class="banners-slot__wrap" v-else>
        <banner
          v-for="banner in BANNERS"
          :key="banner.id"
          :data="banner"
          :slot-name="slotName"
        />
      </div>
    </vue-client-only>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueClientOnly from 'vue-client-only';
import Banner from '@/components/banner/banner.vue'
import Swiper from '@kit/swiper/swiper.vue';

export default {
  name: 'banners-slot',

  components: { Banner, Swiper, VueClientOnly },

  inject: ['adaptive'],

  props: {
    slotName: {
      type: String,
      required: true,
    },
    withCategory: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    BANNERS() {
      return this.$store.state.banners[this.slotName] || [];
    },
    bannersCounter() {
      return this.BANNERS.length;
    },
    hasBanners() {
      return !!this.bannersCounter;
    },
    isSliderMode() {
      return this.BANNERS?.length > 2 && this.adaptive.isMobile;
    },
    classes() {
      const base = 'banners-slot';

      return [
        base,
        {[base + '_mode_slider']: this.isSliderMode }
      ];
    }
  },

  methods: {
    ...mapActions('banners', ['getBanners']),
  },

  serverPrefetch() {
    return this.getBanners({
      slots: [this.slotName],
      withCategory: this.withCategory
    });
  },
}
</script>

<style lang="scss">
.banners-slot {
  display: flex;
  flex-direction: column;

  &_mode_slider {
    flex-direction: row;
  }

  @include breakpoint("tablet") {
    flex-direction: row;
  }

  &__wrap {
    display: flex;
    flex-direction: column;

    @include breakpoint("tablet") {
      flex-direction: row;
    }
  }

  .banner {
    flex: 0 1 auto;
    margin-bottom: $mobileOffset;

    @include breakpoint("tablet") {
      margin-right: $mobileOffset;
      margin-bottom: 0;

      &:last-child {
        margin-right: 0;
      }
    }

    @include breakpoint("desktop") {
      margin-right: $mobileOffsetDesktop;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
